/**
 * Web api model
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace WebApiModel {
  export class AutocompleteItem {
    type: string; // This would be one of People, Places, Service Categories, and Service Descriptions
    name: string;
    id: string;
    placeLocation: string; // Autocomplete places have a separate field for location to be displayed in the dropdown list
    // defaultCategory: string;
    defaultCategory?: string; // Make it optional with a "?" and provide a default value if needed
    allResultsCount: number;
  }

  export class AutocompleteLocationItem {
    name: string;
  }

  export class ServiceCategory {
    name: string;
    services: string[];
  }

  export interface ProfileDetail {
    id: string;
  }

  export class Phone {
    description: string;
    number: number;
  }

  export class Person implements ProfileDetail {
    id: string;
    sortField: string;
    title: string;
    firstName: string;
    lastName: string;
    notes: string;
    specialty: string;
    subSpecialty: string;
    specialInterest: string;
    specialist: string;
    isAffiliatedProvider: boolean;
    isConsultant: boolean;
    isTelehealth: boolean;
    phones: Phone[];
    fax: string;
    emailAddress: string;
    webAddress: string;
    serviceCategoryNames: string[];
    serviceCategories: ServiceCategory[];
    places: Place[];
  }

  export class Place implements ProfileDetail {
    id: string;
    sortField: string;
    practiceName: string;
    facilityName: string;
    receptionLocation: string;
    address: string;
    suburb: string;
    city: string;
    postcode: string;
    region: string;
    notes: string;
    isAffiliatedProvider: boolean;
    isEasyClaim: boolean;
    isConsultant: boolean;
    isTelehealth: boolean;
    phones: string[];
    fax: string;
    emailAddress: string;
    webAddress: string;
    latitude: number;
    longitude: number;
    serviceCategories: ServiceCategory[];
    serviceCategoryNames: string[];
    people: Person[];
    distance: number;
  }

  export class Location {
    address: string;
    suburb: string;
    city: string;
    postcode: string;
    latitude: number;
    longitude: number;
    locationDetails: LocationDetail[];
    isAffiliatedProvider: boolean;
    isEasyClaim: boolean;
    isTelehealth: boolean;
  }

  export class LocationDetail {
    id: string;
    practiceName: string;
    receptionLocation: string;
    isAffiliatedProvider: boolean;
    isEasyClaim: boolean;
    personId: string;
    title: string;
    displayName: string;
    webAddress: string;
    isConsultant: boolean;
    isTelehealth: boolean;
  }
}
